var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayIcon = function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M80 40c0 22.09-17.91 40-40 40S0 62.09 0 40 17.91 0 40 0s40 17.91 40 40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    d: "M51.62 23.72c8.95 6.41 11.01 18.85 4.61 27.8-6.41 8.95-18.85 11.01-27.8 4.61s-11.01-18.85-4.61-27.8a19.94 19.94 0 0 1 19.94-7.98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    d: "m40.97 45.68 8-5.15c.3-.2.39-.6.19-.9a.7.7 0 0 0-.21-.21l-11.57-6.88a.656.656 0 0 0-.99.57v14.34"
  })));
};
export default SvgPlayIcon;